export const TEXT = {
  BANNER: {id: 'raf.myaccount.title'},
  BANNER_CTA: {id: 'raf.myaccount.moreinfo'},
} as const;
